import { GlButton, GlLoadingIcon, GlSprintf, GlIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import EditorModeSwitcher from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/markdown/editor_mode_switcher.vue?vue3';
export default {
    name: 'MarkdownToolbar',
    components: {
        GlButton,
        GlLoadingIcon,
        GlSprintf,
        GlIcon,
        EditorModeSwitcher
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        markdownDocsPath: {
            type: String,
            required: true
        },
        canAttachFile: {
            type: Boolean,
            required: false,
            default: true
        },
        showCommentToolBar: {
            type: Boolean,
            required: false,
            default: true
        },
        showContentEditorSwitcher: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    emits: [
        'enable-content-editor'
    ],
    computed: {
        showEditorModeSwitcher () {
            return this.showContentEditorSwitcher;
        }
    }
};
